import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ApiStatus } from "commonModule/services/common"

export interface CreateVerificationSessionRequestRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    bookingNumber: string
  }
}

export interface VerificationSessionResponseData {
  apiStatus: ApiStatus
  data: {
    verificationSessionId: string
    ephemeralKeySecret: string | null
    clientSecret: string
  }
}

export interface CreateVerificationSessionResponse extends AxiosResponse {
  data: VerificationSessionResponseData
}

export function createVerificationSessionApi(
  { params }: CreateVerificationSessionRequestRequest,
  axiosInstance: AxiosInstance,
): Promise<CreateVerificationSessionResponse> {
  const url = `/payment/create-verification-session`
  return axiosInstance({
    method: "get",
    params,
    url,
  }) as Promise<CreateVerificationSessionResponse>
}
